<template>
  <div class='client-groups-view is-flex-col align-center p-6'>
    <h1 class='title is-2'>Your Organizations</h1>
    <div class="columns">
      <div class="column is-one-fifth">
      </div>
      <div class="column is-three-fifths">
      </div>
      <div class="column is-one-fifth">
        <div class="buttons is-right">
          <a class="button is-small is-primary is-rounded" href="/ui/advisor/create-client-group">
            Add Organization
          </a>
        </div>
      </div>
    </div>

    <b-table :data='groups'>
      <b-table-column field='name' label='Name' v-slot='props'>
        <router-link
          :to="{ name: 'edit-client-group', params: { id: props.row.id }}">
          {{ props.row.name }}
        </router-link>
      </b-table-column>

      <b-table-column field='contact' label='Admin'>
        <template v-slot:header="{ column }">
          {{ column.label }}
          <SimpleTooltip label='Some questions, like the mission statement, can only be answered by the admin.'>
            <i class='fa fa-question-circle has-text-info'></i>
          </SimpleTooltip>
        </template>

        <template v-slot='props'>
          {{ props.row.admin ? props.row.admin.name : ' ' }}
        </template>
      </b-table-column>

      <b-table-column field='email' label='Admin Email' v-slot='props'>
        {{ props.row.admin ? props.row.admin.email : ' ' }}
      </b-table-column>

      <b-table-column field='prospects' label='Members' v-slot='props'>
        <div class='is-flex align-center justify-center gap-1-4 text-center'>
          <span
            style="flex-basis: 1em; min-width: 1em">
            {{ props.row.prospects.length }}
          </span>

          <!-- <router-link
            :to="{ name: 'edit-client-group', params: { id: props.row.id }}"
            class='is-size-7'>
            <i class='fa fa-plus mr-1'></i>Add more
          </router-link> -->
        </div>
      </b-table-column>

      <b-table-column field='prospects' label='Questionnaire' v-slot='props'>
        <a @click='showDetails(props.row)'>Send Questionnaire and Check Status</a>
      </b-table-column>

      <b-table-column field='results' label='View Results' v-slot='props'>
        <router-link
          :to="'/advisor/institutional-qnr-results/sections/1?group=' + props.row.id"
          class='is-flex justify-center'>
          <i class='fa fa-chart-bar'></i>
        </router-link>
      </b-table-column>

      <!-- <b-table-column field='fields' label='Fields' v-slot='props'>
        {{ JSON.stringify(Object.keys(props.row.prospect)) }}
      </b-table-column> -->
    </b-table>

    <b-modal v-model='showModal'>
      <ClientGroupView :group='selectedGroup'/>
    </b-modal>
  </div>
</template>


<script>
import ClientGroupView from './ClientGroupView.vue';
import SimpleTooltip from '../../components/core/SimpleTooltip.vue';

export default {
  name: 'client-groups',
  components: { ClientGroupView, SimpleTooltip },
  props: [/* Inputs */],
  data() {
    return {
      groups: [],
      selectedGroup: null,
      showModal: false,
    };
  },
  beforeCreate() {},
  async created() {
    await this.getClientGroups();
  },
  mounted() {},
  updated() {},
  computed: {
  },
  methods: {
    async getClientGroups() {
      const clientGroups = (await (await fetch('/api/v1/client-groups')).json()).client_groups;
      console.log(clientGroups);
      this.groups = clientGroups;
      // hydrate links
    },
    showDetails(group) {
      this.selectedGroup = group;
      this.showModal = true;
    },
  },
};
</script>


<style>
.client-groups-view .table-wrapper {
  min-height: 0;
}
</style>
